import { createBlueprint as e } from "@made-people/blueprint";
const o = e({
  slots: {
    base: "flex gap-3",
    checkbox: "group block size-4 rounded mt-px border bg-white data-[checked]:bg-black border border-black rounded-sm shrink-0 [&>svg]:fill-white p-0.5",
    label: "block text-body-sm text-black"
  },
  variants: {}
}), l = e({
  slots: {
    base: "flex flex-col gap-6 w-full"
  },
  variants: {}
}), a = e({
  slots: {
    base: "flex flex-col gap-2",
    label: "text-heading-2xs",
    fieldWrapper: "w-full flex gap-2 *:w-full",
    description: "text-body-xs text-neutral-800 data-[is-type='error']:text-system-error data-[is-type='warning']:text-system-warning data-[is-type='info']:text-system-info"
  },
  variants: {}
}), r = e({
  slots: {
    input: "peer block w-full placeholder:text-neutral-600 bg-white rounded-md border border-solid border-border-neutral-300 appearance-none focus:outline-none focus:ring-0 focus:border-black focus:text-black"
  },
  variants: {
    size: {
      sm: {
        input: "p-2.5 h-12 text-body-xs"
      },
      md: {
        input: "p-3 text-body-sm"
      },
      lg: {
        input: ""
      }
    },
    disabled: {
      barebone: {
        input: "disabled:border-none disabled:!p-0 text-black disabled:!bg-transparent"
      }
    }
  }
}), s = e({
  slots: {
    base: "relative",
    inputWrapper: "relative",
    input: "peer block w-full text-black bg-transparent rounded-md border border-solid border-neutral-200 appearance-none focus:outline-none focus:ring-0 focus:border-black focus:text-black autofill:bg-white",
    label: "absolute pointer-events-none transition-all ease-[cubic-bezier(0.32,0.72,0,1)] duration-[400ms] transform scale-100 z-10 origin-[0] bg-white peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 peer-data-[has-value=true]:top-2 peer-data-[has-value=true]:scale-75 peer-data-[has-value=true]:-translate-y-4 start-1",
    helperText: "mt-2 text-body-xs text-neutral-600 data-[is-type='error']:text-system-error data-[is-type='warning']:text-system-warning data-[is-type='info']:text-system-info"
  },
  variants: {
    size: {
      sm: {
        input: "px-2.5 text-body-xs h-12",
        label: "px-2.5 text-body-xs"
      },
      md: {
        input: "px-3 text-body-sm",
        label: "px-3 text-body-sm"
      },
      lg: {
        input: "",
        label: ""
      }
    },
    disabled: {
      barebone: {
        input: "disabled:border-none disabled:!p-0"
      }
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), n = e({
  slots: {
    base: "group border-box relative flex items-center justify-center w-5 h-5 border rounded-full cursor-pointer transition-colors data-[checked]:border-black data-[unchecked]:border-gray-300 data-[unchecked]:bg-transparent",
    label: "ml-2 text-gray-700 select-none flex flex-row items-center justify-center gap-2",
    indicator: "absolute w-3 h-3 rounded-full bg-black opacity-0 transition-opacity group-data-[checked]:opacity-100"
  },
  variants: {}
}), i = e({
  slots: {
    base: "flex flex-row gap-2 w-full"
  },
  variants: {}
}), u = e({
  slots: {
    base: "relative w-full flex flex-col gap-2",
    fieldLabel: "text-body-sm",
    listBoxButton: "relative items-center w-full text-left focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-black cursor-pointer peer block w-auto text-black bg-transparent rounded-md border border-solid border-neutral-200 appearance-none focus:outline-none focus:ring-0 focus:border-black focus:text-black autofill:bg-white px-2.5 text-body-sm h-11",
    listBoxArrow: "w-3 h-3 flex items-center justify-center absolute top-1/2 right-4 -translate-y-1/2",
    listBoxOptions: "w-[var(--button-width)] absolute z-20 mt-1 !max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in",
    listBoxOption: "flex px-3 justify-between items-center group relative select-none py-2 data-[focus]:bg-neutral-100 text-black data-[focus]:outline-none",
    listBoxLabel: "block truncate text-label-md group-data-[selected]:font-medium",
    listBoxIcon: "flex items-center justify-center h-5 w-5 mr-2 relative",
    listBoxCheck: "relative w-2.5 h-2.5 flex items-center justify-center text-black group-[&:not([data-selected])]:hidden group-data-[focus]:text-white"
  },
  variants: {
    style: {
      border: {
        listBoxButton: "outline outline-1 -outline-offset-1 outline-neutral-200 bg-white"
      },
      solid: {
        listBoxButton: ""
      }
    },
    rounded: {
      full: {
        listBoxButton: "rounded-full pl-5 pr-10",
        listBoxOption: "px-3"
      },
      md: {
        listBoxButton: "rounded-md px-3",
        listBoxOption: "px-3"
      }
    },
    size: {
      sm: {
        listBoxButton: "h-8",
        listBoxOption: "px-3"
      },
      md: {
        listBoxButton: "pl-4 pr-12",
        listBoxOption: "px-3"
      },
      lg: {
        listBoxButton: "pl-5 pr-10",
        listBoxOption: "px-3"
      }
    }
  },
  defaultVariants: {
    style: "border"
  }
});
export {
  o as checkboxBlueprint,
  l as formBlueprint,
  a as formGroupBlueprint,
  r as inputFieldDefaultBlueprint,
  s as inputFieldFloatingLabelBlueprint,
  n as radioButtonBlueprint,
  i as radioGroupBlueprint,
  u as selectboxBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
